/**
 * Cấu hình khóa Local Storage cho lưu trữ dữ liệu.
 * Yêu cầu:
 *  - Cần đặt tên khóa đúng cú pháp để tránh sự trùng lặp tên khóa.
 *  - Cần viết mô tả cho khóa đã khai báo:
 *    vd: // Khóa lưu trữ <Nội dung thông tin> trong chức năng <Tên chức năng>
 *  - Cần quy hoạch khóa dựa theo chức năng (feature) hoặc toàn ứng dung (global):
 *  - Xem mẫu ở dưới nhé!!!
 * */
export const LocalStorageConfigKeys = {
  global: {
    transloco: {
      // Khóa lưu trữ ngôn ngữ hiện tại của Transloco.
      currentLanguage: 'global.transloco.currentLangulage',
    },
    layouts: {
      themeSetting: 'global.layouts.themeSetting',
      currentThemeMode: 'global.layouts.currentThemeMode',

      widget: {
        lockscreen: 'global.layouts.widget.lockscreen',
      }
    },

    routing: {
      // Khóa lưu trữ URL trước đó trong định tuyến sau khi login thành công.
      previousUrl: 'global.routing.previousUrl',
      devPreviousUrl: 'global.routing.devPreviousUrl',
    },
  },
  feature: {
    /**
     * @deprecated
     * Need upgrade logic get this key to StorageHelper.getActionsActive()
     */
    auth: {
      actionIds: '___core_feature.authenticate.list_action_active',
    },

    adminPermissionV2: {
      confApp: {
        filters: `features.managePermission.confApp.filters`,
        appsCacheClient: `features.managePermission.confApp.cacheClient`,
      },
      confApi: {
        filters: 'features.managePermission.confApi.filters',
      },
      confMenu: {
        filters: 'features.managePermission.confMenu.filters',
      },
      confRole: {
        filters: 'features.managePermission.confRole.filters',
        // USER
        fullScreenListAddUserToRole: 'features.managePermission.confRole.fullScreenListAddUserToRole',
        fullScreenModalAddUserToRole: 'features.managePermission.confRole.fullScreenModalAddUserToRole',

        // MENU
        fullScreenListAddMenuToRole: 'features.managePermission.confRole.fullScreenListAddMenuToRole',
        fullScreenModalAddMenuToRole: 'features.managePermission.confRole.fullScreenModalAddMenuToRole',

        // API
        fullScreenListAddApiToRole: 'features.managePermission.confRole.fullScreenListAddApiToRole',
        fullScreenModalAddApiToRole: 'features.managePermission.confRole.fullScreenModalAddApiToRole',
      },
      confUser: {
        filters: 'features.managePermission.confUserManage.filters',
        fullScreen: {
          tabs: {
            roleOfUser:
              'features.managePermission.confUserManage.fullScreen.tabs.roleOfUser.filters',
            modelAddRole:
              'features.managePermission.confUserManage.fullScreen.tabs.roleOfUser.modelAddRole.filters',
          },
        },
      },
    },
    layouts: {
      tabSetting: {
        themeMode: 'feature.layouts.tabSetting.themeMode',
      },
      themeSetting: 'feature.layouts.themeSetting',
    },
  },
};
